import { Calendar } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CalendarIcon = createLucideIcon(Calendar);
